import { Box, Dialog, IconButton } from "@mui/material";

const styles = {
  closeIcon: {
    color: "primary.main",
    fontSize: 14,
    position: "absolute",
    right: 10,
    top: 10,
  },
};

interface Props {
  children: React.ReactNode;
  handleClose?: () => void;
  isMobileScreen?: boolean;
  isDialog?: boolean;
}

const CreateTemplateDialogWrapper = ({
  children,
  handleClose,
  isMobileScreen,
  isDialog,
}: Props) => {
  if (!isDialog) {
    return <>{children}</>;
  }
  return (
    <Dialog
      maxWidth="lg"
      fullWidth
      scroll="body"
      fullScreen={isMobileScreen}
      open={true}
      onClose={handleClose}
    >
      <IconButton sx={styles.closeIcon} onClick={handleClose}>
        <Box component="i" className="fa-regular fa-xmark" />
      </IconButton>
      {children}
    </Dialog>
  );
};

export default CreateTemplateDialogWrapper;
